import Vue from 'vue';
import Vuex from 'vuex';
import { getUserInfo } from '../api/user';
import { getLanguage } from '../lang/index';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: null,
    language: getLanguage(),
  },
  mutations: {
    setUserInfo(state, payload) {
      state.userInfo = payload.userInfo;
    },
    setLanguage: (state, language) => {
      state.language = language;
      localStorage.setItem('language', language);
    },
  },
  actions: {
    getUserInfo({ commit }) {
      return getUserInfo().then(res => {
        commit({
          type: 'setUserInfo',
          userInfo: res.data.data,
        });
        return res.data.data;
      }).catch();
    },
    setLanguage({ commit }, language) {
      commit('setLanguage', language);
    },
  },
});
